var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBikeLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8528_50098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0275 16.2783C41.333 19.0704 42.5525 23.6887 41.055 27.7437C39.9599 30.709 37.5572 32.9533 34.5697 33.8014L19.1953 38.2312L18.2588 34.9328L33.6333 30.503C35.6106 29.9416 37.2009 28.4562 37.9257 26.4936C38.9169 23.8097 38.1097 20.7529 35.9219 18.9049L35.7664 18.7736C34.0276 17.305 31.7078 16.7927 29.5589 17.4028L19.0683 20.3812L18.1318 17.0828L28.6224 14.1044C31.8245 13.1953 35.2811 13.9586 37.872 16.147L38.0275 16.2783Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4072 20.2949L12.5999 22.983L9.7961 25.2701L7.60341 22.582L10.4072 20.2949Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17008 21.5183C4.35277 20.5535 6.09358 20.7302 7.0583 21.9129L21.1015 39.129C22.0662 40.3117 21.8895 42.0525 20.7069 43.0172C19.5242 43.982 17.7834 43.8053 16.8186 42.6226L2.77542 25.4065C1.8107 24.2238 1.9874 22.483 3.17008 21.5183Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4042 29.4499C11.6636 28.4226 13.5174 28.6108 14.5447 29.8702L22.1097 39.1445C23.137 40.4039 22.9489 42.2577 21.6894 43.285L20.773 44.0325C19.5136 45.0598 17.6598 44.8716 16.6325 43.6122L9.06749 34.338C8.04018 33.0785 8.22835 31.2248 9.48776 30.1975L10.4042 29.4499Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9636 15.4048C9.38072 15.9935 8.43098 15.9982 7.8423 15.4153L3.79237 11.4053C3.20369 10.8224 3.19898 9.8727 3.78186 9.28402C4.36474 8.69534 5.31447 8.69063 5.90316 9.27351L9.95308 13.2835C10.5418 13.8664 10.5465 14.8161 9.9636 15.4048Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3569 12.8812C14.5352 12.9867 13.7836 12.4062 13.678 11.5845L12.9904 6.23089C12.8848 5.40921 13.4654 4.65755 14.2871 4.55201C15.1087 4.44647 15.8604 5.02701 15.9659 5.84869L16.6536 11.2023C16.7591 12.024 16.1786 12.7756 15.3569 12.8812Z",
    fill: "#B1B0F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8528_50098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeLock);
export default __webpack_public_path__ + "static/media/bikeLock.478a9b06cf38fd1e2aa0992af975f417.svg";
export { ForwardRef as ReactComponent };